import icatImage from '../assets/images/icat.png';

// --- INLINE SVG ICONS (Hatasız ve Hızlı) ---
const Icons = {
  Gamepad: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <line x1="6" y1="12" x2="10" y2="12" />
      <line x1="8" y1="10" x2="8" y2="14" />
      <line x1="15" y1="13" x2="15.01" y2="13" />
      <line x1="18" y1="11" x2="18.01" y2="11" />
      <rect x="2" y="6" width="20" height="12" rx="2" />
    </svg>
  ),
  Puzzle: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M19.439 15.424a1 1 0 00-1.424-1.424l-3.5 3.5a1 1 0 001.424 1.424l3.5-3.5zM4 12a1 1 0 00-1 1v5a1 1 0 001 1h5a1 1 0 001-1v-5a1 1 0 00-1-1H4z" />
      <path d="M10 9H6a2 2 0 00-2 2v4" />
      <path d="M14.5 9h-2a2 2 0 00-2 2v2" />
      <circle cx="12" cy="12" r="9" />
    </svg>
  ),
  Palette: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="13.5" cy="6.5" r=".5" />
      <circle cx="17.5" cy="10.5" r=".5" />
      <circle cx="8.5" cy="7.5" r=".5" />
      <circle cx="6.5" cy="12.5" r=".5" />
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
    </svg>
  ),
  Music: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M9 18V5l12-2v13" />
      <circle cx="6" cy="18" r="3" />
      <circle cx="18" cy="16" r="3" />
    </svg>
  ),
  Book: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  Calculator: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect x="4" y="2" width="16" height="20" rx="2" />
      <line x1="8" y1="6" x2="16" y2="6" />
      <line x1="16" y1="14" x2="16" y2="18" />
      <path d="M16 10h.01" />
      <path d="M12 10h.01" />
      <path d="M8 10h.01" />
      <path d="M12 14h.01" />
      <path d="M8 14h.01" />
      <path d="M12 18h.01" />
      <path d="M8 18h.01" />
    </svg>
  ),
  Globe: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  Robot: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect x="3" y="11" width="18" height="10" rx="2" />
      <circle cx="12" cy="5" r="2" />
      <path d="M12 7v4" />
      <line x1="8" y1="16" x2="8" y2="16" />
      <line x1="16" y1="16" x2="16" y2="16" />
    </svg>
  ),
  Rocket: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
      <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
    </svg>
  ),
  Smile: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="12" cy="12" r="10" />
      <path d="M8 14s1.5 2 4 2 4-2 4-2" />
      <line x1="9" y1="9" x2="9.01" y2="9" />
      <line x1="15" y1="9" x2="15.01" y2="9" />
    </svg>
  ),
  Star: ({ className = "" }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  )
};

const activities = [
  {
    icon: Icons.Gamepad,
    title: 'Eğlenceli Oyunlar',
    emoji: '🎮',
    description: 'Öğrenirken eğlenebileceğin sürü sürü oyun! Matematik, okuma, fen... Hepsi oyun içinde!',
    theme: {
      color: 'text-purple-600',
      bg: 'bg-purple-50',
      border: 'border-purple-100',
      iconBg: 'bg-purple-100',
      button: 'bg-purple-600 hover:bg-purple-700',
      shadow: 'hover:shadow-purple-200'
    }
  },
  {
    icon: Icons.Puzzle,
    title: 'Bulmaca Dünyası',
    emoji: '🧩',
    description: 'Zeka geliştiren yüzlerce bulmaca! Mantık, hafıza ve problem çözme becerilerini geliştir!',
    theme: {
      color: 'text-pink-600',
      bg: 'bg-pink-50',
      border: 'border-pink-100',
      iconBg: 'bg-pink-100',
      button: 'bg-pink-600 hover:bg-pink-700',
      shadow: 'hover:shadow-pink-200'
    }
  },
  {
    icon: Icons.Palette,
    title: 'Sanat Atölyesi',
    emoji: '🎨',
    description: 'Çiz, boya ve yarat! Hayal gücünü kullanarak kendi sanat eserlerini oluştur!',
    theme: {
      color: 'text-orange-600',
      bg: 'bg-orange-50',
      border: 'border-orange-100',
      iconBg: 'bg-orange-100',
      button: 'bg-orange-500 hover:bg-orange-600',
      shadow: 'hover:shadow-orange-200'
    }
  },
  {
    icon: Icons.Music,
    title: 'Müzik Eğlencesi',
    emoji: '🎵',
    description: 'Şarkılar söyle, ritim tut! Müzikle öğrenmek çok eğlenceli!',
    theme: {
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      border: 'border-blue-100',
      iconBg: 'bg-blue-100',
      button: 'bg-blue-600 hover:bg-blue-700',
      shadow: 'hover:shadow-blue-200'
    }
  },
  {
    icon: Icons.Book,
    title: 'Hikaye Zamanı',
    emoji: '📚',
    description: 'Harika hikayeler dinle ve kendi hikayelerini yaz! Okuma becerin gelişsin!',
    theme: {
      color: 'text-green-600',
      bg: 'bg-green-50',
      border: 'border-green-100',
      iconBg: 'bg-green-100',
      button: 'bg-green-600 hover:bg-green-700',
      shadow: 'hover:shadow-green-200'
    }
  },
  {
    icon: Icons.Calculator,
    title: 'Matematik Macerası',
    emoji: '🔢',
    description: 'Sayılarla dost ol! Toplama, çıkarma, çarpma... Hepsi bir oyun!',
    theme: {
      color: 'text-yellow-600',
      bg: 'bg-yellow-50',
      border: 'border-yellow-100',
      iconBg: 'bg-yellow-100',
      button: 'bg-yellow-500 hover:bg-yellow-600',
      shadow: 'hover:shadow-yellow-200'
    }
  },
  {
    icon: Icons.Globe,
    title: 'Dünya Keşfi',
    emoji: '🌍',
    description: 'Ülkeleri, kıtaları keşfet! Dünyanın her yerini gezmeye hazır mısın?',
    theme: {
      color: 'text-teal-600',
      bg: 'bg-teal-50',
      border: 'border-teal-100',
      iconBg: 'bg-teal-100',
      button: 'bg-teal-600 hover:bg-teal-700',
      shadow: 'hover:shadow-teal-200'
    }
  },
  {
    icon: Icons.Robot,
    title: 'Kodlama Dünyası',
    emoji: '🤖',
    description: 'Kendi robotunu kodla! Geleceğin mucidi sen olacaksın!',
    theme: {
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      border: 'border-indigo-100',
      iconBg: 'bg-indigo-100',
      button: 'bg-indigo-600 hover:bg-indigo-700',
      shadow: 'hover:shadow-indigo-200'
    }
  },
];

export const Services = () => {
  return (
    <div className="min-h-screen bg-[#FDFDFC] font-sans relative overflow-hidden">

      {/* --- BACKGROUND BLOBS --- */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute top-[-10%] left-[-10%] w-[600px] h-[600px] bg-purple-100/40 rounded-full blur-[100px] animate-pulse" />
        <div className="absolute top-[20%] right-[-10%] w-[500px] h-[500px] bg-yellow-100/40 rounded-full blur-[100px]" />
        <div className="absolute bottom-[-10%] left-[30%] w-[600px] h-[600px] bg-pink-100/40 rounded-full blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 py-16 md:py-24 relative z-10">

        {/* --- HEADER --- */}
        <div className="text-center max-w-5xl mx-auto mb-20">
          <div className="inline-flex items-center gap-2 bg-white border border-gray-100 shadow-sm rounded-full px-5 py-2 mb-8 transform hover:scale-105 transition-transform cursor-default">
            <Icons.Smile className="text-yellow-400 w-5 h-5" />
            <span className="text-sm font-bold text-gray-500 tracking-wide uppercase">Keşfetmeye Hazır Mısın?</span>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-6">
            {/* Sol: Başlık ve Açıklama */}
            <div className="text-center lg:text-left">
              <h1 className="text-5xl md:text-7xl font-black text-gray-900 tracking-tight leading-tight mb-6">
                Neler Yapabilirsin? <span className="inline-block animate-bounce">🌟</span>
              </h1>

              <p className="text-xl md:text-2xl text-gray-600 font-medium">
                Seni bekleyen süper aktiviteler! Seçimini yap ve maceraya başla.
              </p>
            </div>

            {/* Sağ: İcat Görseli */}
            <div className="relative group">
              <div className="absolute inset-4 bg-gradient-to-tr from-purple-300 to-pink-300 rounded-[3rem] blur-2xl opacity-30 group-hover:opacity-50 transition-opacity duration-500" />
              <img
                src={icatImage}
                alt="Mucittin İcatları"
                className="relative w-full max-w-md mx-auto rounded-[3rem] shadow-2xl border-4 border-white transform transition-transform duration-500 group-hover:rotate-2 group-hover:scale-[1.05]"
              />
            </div>
          </div>
        </div>

        {/* --- ACTIVITIES GRID --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {activities.map((activity, index) => {
            const Icon = activity.icon;
            return (
              <div
                key={index}
                className={`group relative bg-white border-2 ${activity.theme.border} rounded-[2.5rem] p-6 flex flex-col items-center text-center transition-all duration-300 hover:shadow-2xl ${activity.theme.shadow} transform hover:-translate-y-2 cursor-pointer`}
              >
                {/* Icon Container with Emoji */}
                <div className="relative mb-6">
                  <div className={`w-24 h-24 ${activity.theme.iconBg} rounded-[1.5rem] flex items-center justify-center shadow-lg shadow-gray-100 transform -rotate-3 group-hover:rotate-3 transition-transform duration-300`}>
                    <Icon className={`w-10 h-10 ${activity.theme.color}`} />
                  </div>
                  <div className="absolute -top-3 -right-3 text-4xl animate-bounce" style={{ animationDuration: '3s' }}>
                    {activity.emoji}
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-2xl font-black text-gray-900 mb-3 group-hover:text-gray-700 transition-colors">
                  {activity.title}
                </h3>

                <p className="text-gray-500 font-medium leading-relaxed mb-8 flex-grow">
                  {activity.description}
                </p>

                {/* Button */}
                <button className={`w-full py-3.5 rounded-xl font-bold text-white text-lg ${activity.theme.button} shadow-lg transition-all transform active:scale-95 flex items-center justify-center gap-2`}>
                  <span>Hemen Dene</span>
                  <Icons.Rocket className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            );
          })}
        </div>

        {/* --- FOOTER CTA --- */}
        <div className="mt-24 text-center">
          <div className="relative bg-gradient-to-r from-yellow-400 via-orange-400 to-red-400 rounded-[3rem] p-12 md:p-20 overflow-hidden shadow-2xl shadow-orange-200 transform hover:scale-[1.02] transition-transform duration-500">
            {/* Pattern Overlay */}
            <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle, white 2px, transparent 2px)', backgroundSize: '24px 24px' }}></div>

            <div className="relative z-10 max-w-3xl mx-auto text-white space-y-6">
              <div className="inline-block bg-white/20 backdrop-blur-md rounded-full px-6 py-2 mb-4">
                <span className="font-bold tracking-wider uppercase text-sm">Sürprizler Yolda</span>
              </div>

              <h2 className="text-4xl md:text-6xl font-black leading-tight">
                Daha Fazlası Geliyor! 🎈
              </h2>

              <p className="text-xl md:text-2xl font-medium opacity-90">
                Her hafta yeni aktiviteler ve oyunlar ekliyoruz! Hiçbirini kaçırma! 🌟
              </p>
            </div>

            {/* Floating Elements */}
            <div className="absolute top-10 left-10 opacity-30 animate-pulse">
              <Icons.Star className="w-16 h-16 text-white" />
            </div>
            <div className="absolute bottom-10 right-10 opacity-30 animate-bounce" style={{ animationDuration: '4s' }}>
              <Icons.Star className="w-24 h-24 text-white" />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};